import React, { Component } from 'react';
import {
    Row, Col,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Form, FormGroup, Label, Input,
    Alert, Card, Collapse
} from 'reactstrap';
import Button from 'reactstrap/lib/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck } from '@fortawesome/pro-solid-svg-icons';

class QuickOrderModal extends Component {
    state = {
        copied: false,
        showQuickOrderForm: false,
        storeUrl: process.env.REACT_APP_STORE_URL || 'https://www.taydaelectronics.com',
        currentStep: 1,
        buildNowChecked: false,
        reservationSubmitted: false,
        reservedOrderNumber: null
    }

    componentDidUpdate(prevProps) {
        // Reset to step 1 when modal opens
        if (this.props.isOpen && !prevProps.isOpen) {
            this.setState({ currentStep: 1, showQuickOrderForm: false, buildNowChecked: false, reservationSubmitted: false, reservedOrderNumber: null });
        }
    }

    copyToClipboard = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text).then(() => {
            this.setState({ copied: true });
            if (this._copyTimer) clearTimeout(this._copyTimer);
            this._copyTimer = setTimeout(() => this.setState({ copied: false }), 1500);
        }).catch((err) => {
            console.error('Failed to copy: ', err);
        });
    }

    // Get product quantity for ordering - multiply by box qty from Step 1
    getProductQty = (product) => {
        const boxQty = parseInt(this.props.qty) || 1;
        return boxQty * (product.qty || 1);
    }

    // Get product quantity for display - multiply by box qty from Step 1
    getProductDisplayQty = (product) => {
        const boxQty = parseInt(this.props.qty) || 1;
        return boxQty * (product.qty || 1);
    }

    generateAddToCartUrl = (products, include_placeholder = false) => {
        if (!products || products.length === 0) return null;

        let filteredProducts = include_placeholder
            ? products
            : products.filter(product => !product.is_placeholder);

        if (filteredProducts.length === 0) return null;

        const skus = filteredProducts.map(product => product.sku).join(',');
        const qtys = filteredProducts.map(product => this.getProductDisplayQty(product)).join(',');

        return `${this.state.storeUrl}/direct/index/add/?product=${skus}&qty=${qtys}`;
    }

    getProductsDiv = (products, include_placeholder) => {
        if (!include_placeholder) {
            products = products.filter(product => !product.is_placeholder);
        }
        var allProductsText = products.map(product => `${product.sku}, ${this.getProductDisplayQty(product)}`).join('\n');
        return (
            <Card className="bg-light p-2">
                {products.length > 0 && (
                    <div>
                        {this.state.copied ? (
                            <FontAwesomeIcon icon={faCheck} className='float-right text-success' alt='Copied' title='Copied'
                                style={{ marginLeft: '10px' }}
                            />
                        ) : (
                            <FontAwesomeIcon icon={faCopy} className='float-right' alt='Copy to Clipboard' title='Copy to Clipboard'
                                style={{ marginLeft: '10px', cursor: 'pointer' }}
                                onClick={() => this.copyToClipboard(allProductsText)}
                            />
                        )}
                        {products.map((product, index) => (
                            <div key={"boxConfigProduct" + this.props.boxConfiguration.id + "-" + product.sku + "-" + index}>
                                <div title={product.product_name}>{product.sku},{this.getProductDisplayQty(product)}</div>
                            </div>
                        ))}
                    </div>
                )}
            </Card>
        )
    }

    showProductCopyDiv = () => {
        const { boxConfiguration, separateProducts } = this.props;

        if (separateProducts) {
            var encl_products = boxConfiguration.required_products.filter((product) => product.service_type === null || product.is_placeholder);
            var service_products = boxConfiguration.required_products.filter((product) => product.service_type !== null && !product.is_placeholder);
            var enclosureCartUrl = this.generateAddToCartUrl(encl_products, true);
            var serviceCartUrl = this.generateAddToCartUrl(service_products, false);
            return (
                <>
                    <Row>
                        <Col className="col" md={6}>
                            <h5>Enclosure Products</h5>
                            {this.getProductsDiv(encl_products, true)}
                            {enclosureCartUrl && (
                                <a href={enclosureCartUrl} target="_blank" rel="noopener noreferrer" className="btn btn-success btn-sm btn-block mt-2">
                                    Add Enclosures to Cart
                                </a>
                            )}
                        </Col>
                        <Col className="col" md={6}>
                            <h5>Service Products</h5>
                            {this.getProductsDiv(service_products)}
                            {serviceCartUrl && (
                                <a href={serviceCartUrl} target="_blank" rel="noopener noreferrer" className="btn btn-success btn-sm btn-block mt-2">
                                    Add Service Products to Cart
                                </a>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col" md={6}>
                            <div className="text-danger">
                                <p className="my-1">When placing separate orders, include the exact quantity of Drill and UV PLACEHOLDER products that will be used in the linked Service order.</p>
                                <h6 className="my-1">Without PLACEHOLDER products, we can't link the orders correctly and may ship the Enclosures before the Drill/UV services are added.</h6>
                            </div>
                        </Col>
                        <Col className="col" md={6}>
                            <div className="text-danger">
                                <p className="my-1">To link a Service order to an Enclosure order, enter the Enclosure order number in the checkout comment, surrounded by % signs: '%1009999999%'.</p>
                                <h6 className="my-1">If this format is not used, we won't be able to link your orders.</h6>
                            </div>
                        </Col>
                    </Row>
                </>
            )
        } else {
            var allProductsCartUrl = this.generateAddToCartUrl(boxConfiguration.required_products, false);
            return (
                <>
                    <Row>
                        <Col className="col" md={6}>
                            <h5>All Products</h5>
                            {this.getProductsDiv(boxConfiguration.required_products)}
                        </Col>
                    </Row>
                    {allProductsCartUrl && (
                        <Row className="mt-2">
                            <Col className="col" md={6}>
                                <a href={allProductsCartUrl} target="_blank" rel="noopener noreferrer" className="btn btn-success btn-block">
                                    Add To Cart
                                </a>
                            </Col>
                        </Row>
                    )}
                </>
            )
        }
    }

    goToStep = (step) => {
        this.setState({ currentStep: step });
    }

    nextStep = () => {
        this.setState(prevState => ({ currentStep: prevState.currentStep + 1 }));
    }

    nextStepFromStep2 = () => {
        const { onReserve } = this.props;
        const { buildNowChecked, reservationSubmitted } = this.state;

        // If Build Now is checked and not already submitted, call the reserve function
        if (buildNowChecked && onReserve && !reservationSubmitted) {
            onReserve();
            this.setState({ currentStep: 3, reservationSubmitted: true });
        } else {
            this.setState({ currentStep: 3 });
        }
    }

    prevStep = () => {
        this.setState(prevState => ({ currentStep: Math.max(1, prevState.currentStep - 1) }));
    }

    toggleBuildNow = () => {
        this.setState(prevState => ({ buildNowChecked: !prevState.buildNowChecked }));
    }

    getStepStyle = (stepNumber) => {
        const { currentStep } = this.state;
        const baseStyle = {
            padding: '15px',
            marginBottom: '10px',
            borderRadius: '8px',
            border: '2px solid',
            transition: 'all 0.3s ease'
        };

        if (stepNumber === currentStep) {
            // Active step
            return {
                ...baseStyle,
                borderColor: '#007bff',
                backgroundColor: '#f8f9fa',
                opacity: 1
            };
        } else if (stepNumber < currentStep) {
            // Completed step (muted)
            return {
                ...baseStyle,
                borderColor: '#dee2e6',
                backgroundColor: '#f8f9fa',
                opacity: 0.6
            };
        } else {
            // Future step (hidden or very muted)
            return {
                ...baseStyle,
                borderColor: '#dee2e6',
                backgroundColor: '#fff',
                opacity: 0.4,
                display: 'none'
            };
        }
    }

    getStepHeaderStyle = (stepNumber) => {
        const { currentStep } = this.state;
        return {
            display: 'flex',
            alignItems: 'center',
            marginBottom: stepNumber === currentStep ? '15px' : '0',
            cursor: stepNumber < currentStep ? 'pointer' : 'default'
        };
    }

    getStepNumberStyle = (stepNumber) => {
        const { currentStep } = this.state;
        const isActive = stepNumber === currentStep;
        const isCompleted = stepNumber < currentStep;

        return {
            width: '30px',
            height: '30px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '10px',
            fontWeight: 'bold',
            backgroundColor: isActive ? '#007bff' : isCompleted ? '#28a745' : '#dee2e6',
            color: isActive || isCompleted ? '#fff' : '#6c757d'
        };
    }

    renderStep1 = () => {
        const { currentStep } = this.state;
        const { qty, onQtyChange } = this.props;
        const isActive = currentStep === 1;
        const isCompleted = currentStep > 1;

        return (
            <div style={this.getStepStyle(1)}>
                <div
                    style={this.getStepHeaderStyle(1)}
                    onClick={() => isCompleted && this.goToStep(1)}
                >
                    <div style={this.getStepNumberStyle(1)}>
                        {isCompleted ? <FontAwesomeIcon icon={faCheck} /> : '1'}
                    </div>
                    <h5 className="mb-0">How Many Boxes Do You Want?</h5>
                    {isCompleted && (
                        <span className="ml-auto badge badge-secondary" style={{ marginLeft: 'auto' }}>
                            Qty: {qty}
                        </span>
                    )}
                </div>
                {isActive && (
                    <div className="mt-3">
                        <Form>
                            <FormGroup>
                                <Label for="qty">Enter the quantity:</Label>
                                <Input
                                    name="qty"
                                    id="qty"
                                    onChange={onQtyChange}
                                    value={qty}
                                    type="number"
                                    min="1"
                                    style={{ maxWidth: '150px' }}
                                />
                            </FormGroup>
                        </Form>
                        <div className="text-right mt-3">
                            <Button color="primary" onClick={this.nextStep}>
                                Next Step &rarr;
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    renderStep2 = () => {
        const { currentStep, buildNowChecked, reservationSubmitted } = this.state;
        const { boxConfiguration, qty, showAlert, alertMsg, showSuccess, successMsg } = this.props;
        const isActive = currentStep === 2;
        const isCompleted = currentStep > 2;

        if (currentStep < 2) return null;

        const requiredProducts = boxConfiguration.required_products || [];

        return (
            <div style={this.getStepStyle(2)}>
                <div
                    style={this.getStepHeaderStyle(2)}
                    onClick={() => isCompleted && this.goToStep(2)}
                >
                    <div style={this.getStepNumberStyle(2)}>
                        {isCompleted ? <FontAwesomeIcon icon={faCheck} /> : '2'}
                    </div>
                    <h5 className="mb-0">Reserve Your Box Template</h5>
                    {isCompleted && buildNowChecked && (
                        <span className="ml-auto badge badge-success" style={{ marginLeft: 'auto' }}>
                            Reserved
                        </span>
                    )}
                    {isCompleted && !buildNowChecked && (
                        <span className="ml-auto badge badge-secondary" style={{ marginLeft: 'auto' }}>
                            Skipped
                        </span>
                    )}
                </div>
                {isActive && (
                    <div className="mt-3">
                        <Alert color="info" className="mb-3">
                            <strong>A Box Job with the following products will be created:</strong>
                        </Alert>
                        <Card className="bg-light p-3 mb-3">
                            <ul className="mb-0 pl-3">
                                {requiredProducts.filter(p => !p.is_placeholder).map((product, index) => (
                                    <li key={index}>
                                        <strong>{product.name || product.product_name || product.sku}</strong>
                                        <span className="text-muted"> (Qty: {this.getProductDisplayQty(product)})</span>
                                    </li>
                                ))}
                            </ul>
                        </Card>
                        {/* {this.props.requiredDrillHoles > 0 && (
                            <div className="mb-3 p-2" style={{backgroundColor: '#fff3cd', borderRadius: '4px', border: '1px solid #ffc107'}}>
                                <strong>Extra Drill Holes Required:</strong> {this.props.requiredDrillHoles}
                                <div className="text-muted" style={{fontSize: '0.85rem'}}>
                                    The Extra Hole product (A-99999-CST-DR-H1) is included in the products above.
                                </div>
                            </div>
                        )} */}

                        <Card className={`p-3 mb-3 ${buildNowChecked ? 'border-primary' : 'border-secondary'}`} style={{ backgroundColor: buildNowChecked ? '#e7f1ff' : '#f8f9fa' }}>
                            <FormGroup check className="mb-0">
                                <Label check style={{ fontSize: '1.1rem', fontWeight: 'bold', cursor: 'pointer' }}>
                                    <Input
                                        type="checkbox"
                                        checked={buildNowChecked}
                                        onChange={this.toggleBuildNow}
                                        disabled={reservationSubmitted}
                                        style={{ transform: 'scale(1.4)', marginRight: '12px' }}
                                    />{' '}
                                    Yes, Reserve this Box Template Now
                                </Label>
                            </FormGroup>
                            <div className="mt-2 ml-4" style={{ fontSize: '0.9rem' }}>
                                <p className="mb-1">By checking this box and clicking Next, you confirm that:</p>
                                <ul className="mb-0 pl-3">
                                    <li>You are reserving this Box Job Template</li>
                                    <li>Any matching orders placed will automatically create Box Jobs</li>
                                    <li>Once the Box Job is created, you will not be able to change the order</li>
                                </ul>
                            </div>
                            {reservationSubmitted && (
                                <div className="mt-2 ml-4">
                                    <span className="badge badge-success">Already Reserved</span>
                                </div>
                            )}
                        </Card>

                        <Alert color="danger" isOpen={showAlert}>{alertMsg}</Alert>

                        {this.renderAvailableOrders()}

                        {reservationSubmitted && (showSuccess || this.state.reservedOrderNumber) && (
                            <Alert color="success" className="mt-3">
                                {successMsg ? (
                                    <div dangerouslySetInnerHTML={{ __html: successMsg }} />
                                ) : (
                                    <>
                                        <h5 className="alert-heading">Box Job Reserved Successfully!</h5>
                                        <p className="mb-2">
                                            Your Box Job has been reserved{this.state.reservedOrderNumber && <> for <strong>Order #{this.state.reservedOrderNumber}</strong></>}.
                                            It will be created automatically when the order is processed.
                                        </p>
                                    </>
                                )}
                                <hr />
                                <div className="d-flex justify-content-end">
                                    <Button color="success" onClick={this.props.toggle}>
                                        Close
                                    </Button>
                                </div>
                            </Alert>
                        )}

                        {!this.state.reservedOrderNumber && (
                            <div className="d-flex justify-content-between mt-3">
                                <Button color="secondary" outline onClick={this.prevStep}>
                                    &larr; Back
                                </Button>
                                <Button
                                    color={buildNowChecked && !reservationSubmitted ? "primary" : "success"}
                                    onClick={this.nextStepFromStep2}
                                >
                                    {buildNowChecked && !reservationSubmitted ? "Reserve & Order Products" : "Next: Order Products"} &rarr;
                                </Button>
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }

    renderAvailableOrders = () => {
        const { availableOrders, onReserveWithOrder, qty } = this.props;
        const { reservationSubmitted } = this.state;

        if (!availableOrders || availableOrders.length === 0) return null;

        // Filter orders that can fulfill the requested quantity
        const requestedQty = parseInt(qty) || 1;
        const validOrders = availableOrders.filter(order => {
            // Check if ALL required products in the order have enough available_qty
            // to fulfill required_qty * requestedBoxQty
            if (!order.required_products || order.required_products.length === 0) {
                return false;
            }
            return order.required_products.every(product => {
                const requiredTotal = (product.required_qty || 1) * requestedQty;
                const availableTotal = product.available_qty || 0;
                return availableTotal >= requiredTotal;
            });
        });

        if (validOrders.length === 0) return null;

        return (
            <Card className="p-3 mb-3 border-success" style={{ backgroundColor: '#d4edda' }}>
                <h6 className="mb-2">
                    <strong>Available Orders Ready to Build</strong>
                </h6>
                <p className="text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                    These orders have all required products. Click to reserve this template for a specific order:
                </p>
                <div className="list-group">
                    {validOrders.map((order, index) => (
                        <div
                            key={order.order_number || index}
                            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                            style={{ padding: '10px 15px' }}
                        >
                            <div>
                                <strong>Order #{order.order_number}</strong>
                                {order.order_date && (
                                    <span className="text-muted ml-2" style={{ fontSize: '0.85rem' }}>
                                        ({order.order_date})
                                    </span>
                                )}
                            </div>
                            <Button
                                color="success"
                                size="sm"
                                onClick={() => this.handleReserveWithOrder(order.order_number)}
                                disabled={reservationSubmitted}
                            >
                                {reservationSubmitted ? 'Reserved' : 'Reserve for this Order'}
                            </Button>
                        </div>
                    ))}
                </div>
            </Card>
        );
    }

    handleReserveWithOrder = (orderNumber) => {
        const { onReserveWithOrder } = this.props;

        if (onReserveWithOrder && !this.state.reservationSubmitted) {
            onReserveWithOrder(orderNumber);
            this.setState({ reservationSubmitted: true, reservedOrderNumber: orderNumber });
        }
    }

    renderStep3 = () => {
        const { currentStep, showQuickOrderForm, reservationSubmitted } = this.state;
        const { boxConfiguration, separateProducts, onSeparateProductsChange, quickOrderFormLabel, showSuccess, successMsg } = this.props;
        const isActive = currentStep === 3;

        if (currentStep < 3) return null;

        return (
            <div style={this.getStepStyle(3)}>
                <div style={this.getStepHeaderStyle(3)}>
                    <div style={this.getStepNumberStyle(3)}>3</div>
                    <h5 className="mb-0">Order Your Products</h5>
                </div>
                {isActive && (
                    <div className="mt-3">
                        {reservationSubmitted && (
                            <Alert color="success" className="mb-3">
                                <div dangerouslySetInnerHTML={{ __html: successMsg }} />
                            </Alert>
                        )}
                        {!reservationSubmitted && showSuccess && (
                            <Alert color="success" className="mb-3">
                                <div dangerouslySetInnerHTML={{ __html: successMsg }} />
                            </Alert>
                        )}
                        <Alert color="info" className="mb-3">
                            <strong>Add the required products to your cart on TaydaElectronics.com</strong>
                        </Alert>

                        {boxConfiguration.products && boxConfiguration.products.length > 0 && (
                            <div>
                                {this.showProductCopyDiv()}
                                <FormGroup check className="mt-3">
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            checked={separateProducts}
                                            onChange={onSeparateProductsChange}
                                        />{' '}
                                        Separate Enclosures and Service Products
                                    </Label>
                                </FormGroup>
                            </div>
                        )}

                        <div className="my-3">
                            <Button
                                color="link"
                                className="p-0 text-decoration-none"
                                onClick={() => this.setState({ showQuickOrderForm: !showQuickOrderForm })}
                                style={{ textDecoration: 'none' }}
                            >
                                {showQuickOrderForm ? '▼' : '▶'} {quickOrderFormLabel || 'Or Use Quick Order Form'}
                            </Button>
                            <Collapse isOpen={showQuickOrderForm}>
                                <Alert color="info" className="mt-2 mb-0">
                                    <h5 style={{fontSize: "18px"}}>Tayda Electronics Quick Order Form</h5>
                                    <div>
                                        <div>1. Copy the product list above.</div>
                                        <div className='px-3'>You can purchase service products in a separate order if desired.</div>
                                        <div>2. Go to <a href={`${this.state.storeUrl}/quick-order/`} target="_blank" rel="noopener noreferrer">Tayda Electronics Quick Order page</a></div>
                                        <div className='px-3'><a href={`${this.state.storeUrl}/quick-order/`} target="_blank" rel="noopener noreferrer">www.taydaelectronics.com/quick-order</a></div>
                                        <div>3. Paste the product list in the form</div>
                                    </div>
                                </Alert>
                            </Collapse>
                        </div>

                        <div className="d-flex justify-content-between mt-3">
                            <Button color="secondary" outline onClick={this.prevStep}>
                                &larr; Back
                            </Button>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const {
            isOpen,
            toggle,
            boxConfiguration
        } = this.props;

        if (!boxConfiguration) return null;

        return (
            <Modal
                key={`modal-${boxConfiguration.id}`}
                id={`modal-${boxConfiguration.id}`}
                style={{top: '60px'}}
                isOpen={isOpen}
                toggle={toggle}
                size="lg"
            >
                <ModalHeader
                    key={`modalHeader-${boxConfiguration.id}`}
                    id={`modalHeader-${boxConfiguration.id}`}
                    toggle={toggle}
                >
                    Quick Order - {boxConfiguration.name}
                </ModalHeader>
                <ModalBody
                    key={`modalBody-${boxConfiguration.id}`}
                    id={`modalBody-${boxConfiguration.id}`}
                >
                    {this.renderStep1()}
                    {this.renderStep2()}
                    {this.renderStep3()}
                </ModalBody>
                <ModalFooter
                    key={`modalFooter-${boxConfiguration.id}`}
                    id={`modalFooter-${boxConfiguration.id}`}
                >
                    <Button color="secondary" onClick={toggle}>Close</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default QuickOrderModal;
